import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Cookies from 'js-cookie';

import element from '@elements';
import style from './Login.module.scss';

import { AuthData } from '@authSlice/types';
import { useAppDispatch } from '@/store/store';
import { fetchAuth, setAuth } from '@authSlice/AuthSlice';

import Input from '@components/Input/Input';
import Button from '@components/Button/Button';
import FormHead from '@components/FormHead/FormHead';
import PasswordInput from '../PasswordInput/PasswordInput';

const Login = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useAppDispatch();

	const [error, setError] = useState<string | null>(null);
	const [username, setUserName] = useState('');
	const [password, setPassword] = useState('');

	const onHandleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setError(null);

		let authEndpoint = '/default-auth';
		if (username.includes('@')) authEndpoint = '/admin-auth';

		try {
			const { data: authData, error: authError }: AuthData = await dispatch(
				fetchAuth({ username, password: password.trim(), authEndpoint }),
			).unwrap();

			if (authError) {
				setError(authError);
				return;
			}

			if (authData.session_id) {
				if (authEndpoint === '/default-auth') {
					Cookies.set('session_id', authData.session_id, {
						expires: 2,
						path: '/',
					});
					Cookies.set('user_role', 'user', { expires: 2, path: '/' });

					dispatch(setAuth({ role: 'user' }));
					navigate('/service', { replace: true });
				} else {
					Cookies.set('token', authData.session_id, { expires: 2, path: '/' });
					Cookies.set('author_id', authData.author_id, { expires: 2, path: '/' });
					Cookies.set('refresh_id', authData.refresh_id, { expires: 2, path: '/' });
					Cookies.set('expire_dt', authData.expire_dt, { expires: 2, path: '/' });
					Cookies.set('user_role', 'admin', { expires: 2, path: '/' });

					dispatch(setAuth({ role: 'admin' }));
					navigate('/admin', { replace: true });
				}
			}
		} catch (error) {
			console.error('Error:', error);
			setError('Произошла ошибка при авторизации');
		}
	};

	const onHandleRecoverPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		navigate('/password/get-token');
	};

	useEffect(() => {
		if (location.pathname === '/authenticate') {
			Cookies.remove('user', { path: '/' });
			Cookies.remove('u_id', { path: '/' });
		}
	}, [location.pathname]);

	return (
		<div className={style['auth']}>
			<form onSubmit={onHandleLogin} className={style['auth__form']}>
				<a
					href='https://home.teorematelecom.ru/'
					target='_blank'
					rel='noopener noreferrer'
					aria-label='Перейти на сайт Теорема Телеком'
				>
					<img className={element['logo']} src='/logoTT.svg' alt='Teorema Logo' />
				</a>

				<FormHead title={'Личный кабинет'} text={'Система самообслуживания абонентов «Теорема Телеком»'} />

				<Input
					id='input'
					title='Логин или лицевой счёт'
					placeholder='010100000'
					onChange={(e) => setUserName(e.target.value)}
					value={username}
					type='text'
				/>

				<PasswordInput id='password' setPassword={setPassword} placeholder='пароль' title='' value={password} />

				{error && <p className={style['error']}>{error}</p>}

				<div className={style['auth__form-actions']}>
					<Button title='Войти' disabled={false} type='submit' />
					<button type='button' onClick={onHandleRecoverPassword} className={style['auth__form-actions-recover']}>
						Забыли пароль?
					</button>
				</div>
			</form>
		</div>
	);
};

export default Login;
